// TODO Add deep equality checking, etc, etc

export function isJsonEqual(a: any, b: any) {
  return JSON.stringify(a) === JSON.stringify(b);
}
